import { render, staticRenderFns } from "./InsufficientPermissions.vue?vue&type=template&id=b02a72a6"
import script from "./InsufficientPermissions.vue?vue&type=script&lang=ts"
export * from "./InsufficientPermissions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports